<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card
            class="pa-1 mb-1"
    >
        <v-list-item class="px-1">
            <v-list-item-content class="pa-1 ma-0">
                <v-list-item-title class="title body-2">
                    {{model.title}}
                </v-list-item-title>
                <v-list-item-subtitle class="title body-2">
                    {{model.text}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions class="py-0">
            <v-container fluid class="py-0">
                <v-row>
                    <v-col cols="5" md="5" class="pa-0 pa-0 d-flex">
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <span
                                        v-on="on"
                                        class="text-center align-self-center"
                                >{{formattedDate}} {{formattedTime}}</span>
                            </template>
                            <span class="caption">Дата создания события</span>
                        </v-tooltip>
                    </v-col>
                    <v-spacer/>
                    <v-col cols="1" class="pa-0 pa-0">
                        <v-btn
                                x-small
                                icon
                                color="blue lighten-2"
                                @click="$emit('editModel', index)"
                        >
                            <v-icon small>edit</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" class="pa-0 pa-0">
                        <v-btn
                                x-small
                                icon
                                color="red lighten-2"
                                @click="removeMailing"
                        >
                            <v-icon small>delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row justify="start">
                    <v-col class="pa-0 px-1" cols="3">
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-card
                                        v-on="on"
                                        class="text-center body-2"
                                        outlined
                                >
                                    <v-icon small>send</v-icon>
                                    {{model.counter}}
                                </v-card>
                            </template>
                            <span class="body-2">Количество вызовов события</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from 'axios'
import ConstConf from '../../../constconf'

export default {
    name: 'EventCard',
    props: ['model', 'index', 'status'],
    methods: {
        editMailing() {
            this.$emit('editModel', this.index)
        },
        async removeMailing() {
            let res = await this.$dialog['error']({
                title: 'Подтверждение удаления',
                text: 'Вы действительно хотите удалить?',
                persistent: this.persistent,
                actions: {
                    false: 'Отмена',
                    true: {
                        color: 'red',
                        text: 'Подтверждаю',
                        handle: () => {
                            return new Promise(resolve => {
                                setTimeout(resolve, 300)
                            })
                        }
                    }
                }
            })
            if (res !== undefined && res !== false) {
                this.$store.dispatch('events/eventDelete', this.index).then(response => {

                })
                /* axios({
                    method: 'delete',
                    url: ConstConf.event.url + '/event/' + this.model.id
                })
                    .then((response) => {
                        this.$emit('removeModel', this.index)
                        this.snackbar = true
                    })
                    .catch((error) => {
                        console.log('ошибка при записи значения')
                        console.log(error)
                    }) */
            }
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        }
    },
    computed: {
        formattedDate() {
            let theDate = new Date(this.model.created_at * 1000)
            return this.zero(theDate.getDate()) + '.' + this.zero((theDate.getMonth() + 1)) + '.' + theDate.getFullYear()
        },
        formattedTime() {
            let theDate = new Date(this.model.created_at * 1000)
            return this.zero(theDate.getHours()) + ':' + this.zero((theDate.getMinutes()))
        },
        showBadge() {
            return this.model.status === 'warning'
        }
    }
}
</script>

<style scoped>

</style>
